// @core/api/endpoints/fiscalization/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CloseShift } from './close_shift';
import { CreateCorrectionReceipt } from './create_correction_receipt';
import { CreateFiscalPolicy } from './create_fiscal_policy';
import { CreateFiscalProvider } from './create_fiscal_provider';
import { CreateFiscalReceipt } from './create_fiscal_receipt';
import { DeleteFiscalPolicy } from './delete_fiscal_policy';
import { DeleteFiscalProvider } from './delete_fiscal_provider';
import { DeregisterFiscalPoint } from './deregister_fiscal_point';
import { GetFiscalPoint } from './get_fiscal_point';
import { GetFiscalPolicy } from './get_fiscal_policy';
import { GetFiscalPolicyByEntity } from './get_fiscal_policy_by_entity';
import { GetFiscalProvider } from './get_fiscal_provider';
import { GetFiscalReceipt } from './get_fiscal_receipt';
import { GetFiscalSummary } from './get_fiscal_summary';
import { GetShiftReport } from './get_shift_report';
import { ListFiscalPoints } from './list_fiscal_points';
import { ListFiscalPolicies } from './list_fiscal_policies';
import { ListFiscalProviders } from './list_fiscal_providers';
import { ListFiscalReceipts } from './list_fiscal_receipts';
import { ListShifts } from './list_shifts';
import { OpenShift } from './open_shift';
import { RegisterFiscalPoint } from './register_fiscal_point';
import { ResolveFiscalContext } from './resolve_fiscal_context';
import { RetryFiscalReceipt } from './retry_fiscal_receipt';
import { TestFiscalProvider } from './test_fiscal_provider';
import { UpdateFiscalPoint } from './update_fiscal_point';
import { UpdateFiscalPolicy } from './update_fiscal_policy';
import { UpdateFiscalProvider } from './update_fiscal_provider';

// Re-export individual endpoints
export {
  CloseShift,
  CreateCorrectionReceipt,
  CreateFiscalPolicy,
  CreateFiscalProvider,
  CreateFiscalReceipt,
  DeleteFiscalPolicy,
  DeleteFiscalProvider,
  DeregisterFiscalPoint,
  GetFiscalPoint,
  GetFiscalPolicy,
  GetFiscalPolicyByEntity,
  GetFiscalProvider,
  GetFiscalReceipt,
  GetFiscalSummary,
  GetShiftReport,
  ListFiscalPoints,
  ListFiscalPolicies,
  ListFiscalProviders,
  ListFiscalReceipts,
  ListShifts,
  OpenShift,
  RegisterFiscalPoint,
  ResolveFiscalContext,
  RetryFiscalReceipt,
  TestFiscalProvider,
  UpdateFiscalPoint,
  UpdateFiscalPolicy,
  UpdateFiscalProvider,
};

// Namespace export for convenient usage
export const fiscalizationApi = {
  CloseShift,
  CreateCorrectionReceipt,
  CreateFiscalPolicy,
  CreateFiscalProvider,
  CreateFiscalReceipt,
  DeleteFiscalPolicy,
  DeleteFiscalProvider,
  DeregisterFiscalPoint,
  GetFiscalPoint,
  GetFiscalPolicy,
  GetFiscalPolicyByEntity,
  GetFiscalProvider,
  GetFiscalReceipt,
  GetFiscalSummary,
  GetShiftReport,
  ListFiscalPoints,
  ListFiscalPolicies,
  ListFiscalProviders,
  ListFiscalReceipts,
  ListShifts,
  OpenShift,
  RegisterFiscalPoint,
  ResolveFiscalContext,
  RetryFiscalReceipt,
  TestFiscalProvider,
  UpdateFiscalPoint,
  UpdateFiscalPolicy,
  UpdateFiscalProvider,
};
